// extracted by mini-css-extract-plugin
var _1 = "report-sections__pNIoO";
var _2 = "section-card___FDRP";
export { _1 as "reportSections", _2 as "sectionCard" }
